var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductPlaceholder = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12258_50940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12258_50940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21083 2.30819C5.24193 1.88509 5.59417 1.56531 6.0184 1.56531H11.679C12.0985 1.56531 12.4482 1.87709 12.485 2.29492C12.7247 5.01333 13.4935 14.4668 12.7216 15.8282C12.6748 15.9109 12.5905 15.9595 12.4997 15.9874C11.1293 16.41 6.614 16.5212 5.26969 16.032C5.13266 15.9821 5.02974 15.8768 4.98696 15.7374C4.41426 13.8712 5.01618 4.9557 5.21083 2.30819Z",
    fill: "#B2BCEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.36688 7.94844C6.36543 7.72277 6.54797 7.53906 6.77364 7.53906H12.8652C12.8652 7.53906 13.1838 11.7126 13.0635 13.1721L6.80774 13.2177C6.58295 13.2193 6.39945 13.0383 6.39801 12.8135L6.36688 7.94844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5.60913,
    y: 3.6189,
    width: 2.91831,
    height: 0.576456,
    rx: 0.288228,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5.60913,
    y: 4.62793,
    width: 3.89108,
    height: 0.432343,
    rx: 0.216171,
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-placeholder.7fbf40a6d750d30f479aa7d7d7dba871.svg";